export default __webpack_public_path__ + "static/media/yeah-okay.79558b9b.gif";